import React from 'react';
import classNames from 'classnames';
import styles from "./MediaCards.module.css";
import { ProductVideos, ProductBlogs } from "../../../types/Product";
import Image from "next/image";
// Declare for Lazy loading
interface MediaCardsProps {
  productVideos: ProductVideos[];
  productBlogs: ProductBlogs[];
  currentIndex: {
    media: number;
  };
}
const monthMapping: {
  [key: string]: string;
} = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'Jun',
  July: 'Jul',
  August: 'Aug',
  September: 'Sep',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec'
};

// Function to convert date format MMM DD, YYYY
function formatDate(input: string) {
  if (!input) {
    return '';
  } else if (input.startsWith('published')) {
    // clean blog data
    const datePart = input.replace('published ', '');
    const [day, month, year] = datePart.split(' ');
    const shortMonth = monthMapping[month as keyof typeof monthMapping];
    const fullYear = parseInt(year, 10) + 2000;
    const formattedDate = `${shortMonth} ${day}, ${fullYear}`; // change into MMM DD, YYYY

    return formattedDate;
  } else if (input.startsWith('Streamed')) {
    // clean video data
    return input.replace('Streamed', '');
  } else {
    return input; // already in correct date format
  }
}

// Add a Component for easier lazy loading
const MediaCards: React.FC<MediaCardsProps> = ({
  productVideos,
  productBlogs,
  currentIndex
}) => {
  // Function to render media cards in a shuffle: 1 Video, 1 Blog
  const renderMediaCards = () => {
    const combinedContent = [];
    const maxLength = Math.max(productVideos.length, productBlogs.length); // Total Length

    for (let i = 0; i < maxLength; i++) {
      // handle videos with no covers
      const hasVideoCover = productVideos[i]?.Video_Cover;
      const titleClass = classNames(styles.videoTitle, {
        'mt-10': !hasVideoCover
      });
      if (i < productVideos.length) {
        combinedContent.push(<a className={styles.mediaCardContainer} key={`video-${i}`} href={productVideos[i].link} target="_blank">
                        <img className="object-cover rounded-t" src={productVideos[i].Video_Cover} alt='video cover'></img>
                        <div className={styles.tag_video}>
                            <div className={styles.tagText}>VIDEO</div>
                        </div>

                        <div className={titleClass}>{productVideos[i].title}</div>
                        <div className={styles.otherInfo}>
                            <div className="flex">
                                <img src='/assets/heat_views.svg' className="w-4 h-4 justify-center items-center" alt='views' />
                                <div className={styles.mediaViews}>{productVideos[i].views} views</div>
                            </div>
                            <div className={styles.mediaDate}>{formatDate(productVideos[i].Post_Time)}</div>
                        </div>

                    </a>);
      }
      if (i < productBlogs.length) {
        combinedContent.push(<a className={styles.mediaCardContainer} key={`blog-${i}`} href={productBlogs[i].URL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.tag_blog}>
                            <div className={styles.tagText}>BLOG</div>
                        </div>
                        <div className={styles.blogTitle}>{productBlogs[i].Title}</div>
                        <p className={styles.blogDesc}>{productBlogs[i].Description}</p>
                        <div className={styles.otherInfo}>
                            <div className="flex">
                                <img src='/assets/heat_views.svg' className="w-4 h-4 relative justify-center items-center" alt='views' />
                                <div className={styles.mediaViews}>{productBlogs[i].Views} views</div>
                            </div>
                            <div className={styles.mediaDate}>{formatDate(productBlogs[i]["Published Time"])}</div>
                        </div>
                    </a>);
      }
    }
    const visibleContent = combinedContent.slice(currentIndex.media, currentIndex.media + 2);
    return visibleContent;
  };
  return <>
            {renderMediaCards()}
        </>;
};
export default MediaCards;